module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "textcontainer"
  }, [_c('contact')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ca54fd1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact.vue
// module id = 190
// module chunks = 0